import { Middleware, MiddlewareAPI, Dispatch } from 'redux';
import { NavigationActions, NavigateToAction } from './actions';
import { ApplicationState } from '../store';
import { defaultRoutes } from '../routes';
import { getPageByIndex } from '../utilities/routing-utilities';

import { history } from '../history';

export const createNavigationMiddleware = (): Middleware => {
  return (api: MiddlewareAPI) => (next: Dispatch) => (baseAction: any) => {
    const state = api.getState() as ApplicationState;
    if (baseAction.type === NavigationActions.NAVIGATE_FORWARD) {
      const nextUrl = getPageByIndex(defaultRoutes(state), history.location.pathname, currentindex => currentindex + 1);
      history.push(`${nextUrl}`);
    } else if (baseAction.type === NavigationActions.NAVIGATE_BACKWARD) {
      const previousUrl = getPageByIndex(
        defaultRoutes(state),
        history.location.pathname,
        currentindex => currentindex - 1
      );
      history.push(`${previousUrl}`);
    } else if (baseAction.type === NavigationActions.NAVIGATE_TO) {
      const action = baseAction as NavigateToAction;
      const { intakeId = '', offerId = '' } = state.student.offer ?? {};
      history.push(`/${intakeId}/${offerId}${action.url}`);
    }
    return next(baseAction);
  };
};
